import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './style.css';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import App from './App.vue';
import router from './router';
import clickableDirective from './directives/clickable';
import { ensureLatestVersion, setupPwa } from './pwa';

async function bootstrap() {
  // Service worker y actualización a la versión publicada (req. 1.4): si el
  // código es viejo, acá se fuerza la actualización y la app vieja no se monta
  setupPwa(router);
  await ensureLatestVersion();

  const pinia = createPinia();

  const app = createApp(App);
  app.directive('clickable', clickableDirective); // Registra la directiva

  app.use(pinia);
  app.use(router);

  app.mount('#app');
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
}

void bootstrap();
